import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'threads-third-party-glyph-icon'

export function ThreadsSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path d="M23.59 14.831c-.139-.066-.279-.13-.42-.19-.247-4.551-2.734-7.157-6.91-7.184h-.057c-2.497 0-4.574 1.066-5.853 3.006l2.297 1.576c.955-1.45 2.454-1.758 3.558-1.758h.038c1.375.009 2.412.408 3.084 1.188.488.568.815 1.352.977 2.342-1.219-.207-2.537-.271-3.947-.19-3.97.228-6.522 2.544-6.35 5.761.086 1.632.9 3.036 2.289 3.953 1.174.775 2.687 1.155 4.26 1.069 2.075-.114 3.704-.906 4.84-2.355.864-1.1 1.41-2.525 1.65-4.321.99.597 1.723 1.383 2.128 2.327.689 1.606.73 4.245-1.424 6.396-1.887 1.885-4.154 2.7-7.581 2.726-3.802-.029-6.677-1.248-8.546-3.624-1.75-2.225-2.655-5.44-2.689-9.553.034-4.114.938-7.328 2.689-9.553 1.87-2.376 4.744-3.595 8.546-3.624 3.829.029 6.754 1.254 8.695 3.642.951 1.17 1.669 2.643 2.142 4.36l2.691-.718c-.573-2.113-1.475-3.934-2.703-5.445C24.506 1.602 20.867.032 16.178 0h-.019C11.48.032 7.882 1.607 5.465 4.68c-2.152 2.734-3.261 6.54-3.298 11.309v.022c.037 4.77 1.146 8.575 3.298 11.31C7.882 30.392 11.48 31.967 16.159 32h.02c4.16-.029 7.091-1.118 9.507-3.532 3.16-3.157 3.066-7.115 2.024-9.544-.748-1.743-2.172-3.158-4.12-4.093Zm-7.183 6.753c-1.74.099-3.548-.683-3.637-2.355-.066-1.24.883-2.625 3.743-2.79.328-.018.65-.028.965-.028a13.6 13.6 0 0 1 2.895.294c-.33 4.118-2.263 4.786-3.966 4.88Z" />
    </symbol>
  )
}

const ThreadsStandaloneContent = standalone(ThreadsSymbol, ID)

export const Threads = styled(function ThreadsStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-threads">
      <ThreadsStandaloneContent />
    </Icon>
  )
})``

export const ThreadsLightweight = styled(function ThreadsComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-threads">
      {lightweight(ID)}
    </Icon>
  )
})``
